import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { logout } from "../../Store/Action/AuthAction";
import { avatar5 } from "../../Images";
import { useNavigate } from "react-router-dom";
import { InputSwitch } from "primereact/inputswitch";
import { toggleMode } from "../../Store/Action/ThemeAction";

const { $ } = window;

const Navbar = () => {
  const navigate = useNavigate();
  const darkMode = useSelector((state) => state.theme.darkMode);
  let { userInfo } = useSelector((state) => state.auth);

  if (!userInfo) {
    userInfo = {};
  }

  const dispatch = useDispatch();

  const signOut = () => {
    dispatch(logout(navigate));
  };

  const onDarkMode = (e) => {
    dispatch(toggleMode(e.target.value));
    if (e.target.value) {
      localStorage.setItem("dark-mode", true);
    } else {
      localStorage.removeItem("dark-mode");
    }
  };

  return (
    <nav
      className={`main-header navbar navbar-expand ${
        darkMode ? "navbar-dark" : "navbar-white navbar-light"
      }`}
    >
      {/* Left navbar links */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="#" role="button">
            <i className="fas fa-bars" /> &nbsp; Show/Hide Menu
          </a>
        </li>
      </ul>
      {/* Right navbar links */}
      <ul className="navbar-nav ml-auto">
        <div className="d-flex justify-content-center align-items-center">
          <a className="nav-link">
            <span>Dark Mode</span>
          </a>
          <InputSwitch checked={darkMode} onChange={onDarkMode} />
        </div>
        <li className="nav-item dropdown">
          <a className="nav-link pointer" data-toggle="dropdown">
            <i className="far fa-user mr-2" />
            <span>{userInfo && userInfo.fullname}</span>
          </a>
          <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <div className="d-flex flex-column align-items-center mt-2 mb-2">
              <div className="mt-3 mb-3">
                <img
                  src={userInfo.image_name ? userInfo.image_name : avatar5}
                  alt="A"
                  className="img-circle elevation-2"
                  style={{ width: 90, height: 90 }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = avatar5;
                  }}
                />
              </div>
              <div style={{ fontWeight: 600 }}>
                {userInfo && userInfo.fullname}
              </div>
              <div
                style={{ fontSize: 12, margin: "0 24px", textAlign: "center" }}
              >
                {userInfo.role}
              </div>
              <div
                className="mb-3"
                style={{
                  fontSize: 14,
                  margin: "0 24px",
                  textAlign: "center",
                  fontWeight: 600,
                }}
              >{`Office - ${userInfo.office}`}</div>
            </div>
            <div className="dropdown-divider" />
            <div className="d-flex justify-content-center mt-2 mb-2">
              <NavLink
                to={`user/profile/${userInfo.userid}`}
                className="btn btn-sm mr-2"
                style={{ width: 120 }}
              >
                <i className={`fa fa-user ${darkMode && "text-warning"}`}>
                  {" "}
                  Profile{" "}
                </i>
              </NavLink>
              <div style={{ width: 1, background: "#ccc", height: 30 }} />
              <button
                type="button"
                className="btn btn-sm"
                style={{ width: 120 }}
                onClick={signOut}
              >
                <i
                  className={`fas fa-sign-out-alt ${
                    darkMode && "text-warning"
                  }`}
                >
                  {" "}
                  Sign Out
                </i>
              </button>
            </div>
          </div>
        </li>
        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i className="fas fa-expand-arrows-alt" />
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
